export default "__VITE_ASSET__BPkZ6$O$__"